/* Knockout bindings for dates */

ko.bindingHandlers.datepicker = {

    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const monthsLabel = {
            January: $.cdh.languageConstant.getConstant('DatePicker.Months.January'),
            February: $.cdh.languageConstant.getConstant('DatePicker.Months.February'),
            March: $.cdh.languageConstant.getConstant('DatePicker.Months.March'),
            April: $.cdh.languageConstant.getConstant('DatePicker.Months.April'),
            May: $.cdh.languageConstant.getConstant('DatePicker.Months.May'),
            June: $.cdh.languageConstant.getConstant('DatePicker.Months.June'),
            July: $.cdh.languageConstant.getConstant('DatePicker.Months.July'),
            August: $.cdh.languageConstant.getConstant('DatePicker.Months.August'),
            September: $.cdh.languageConstant.getConstant('DatePicker.Months.September'),
            October: $.cdh.languageConstant.getConstant('DatePicker.Months.October'),
            November: $.cdh.languageConstant.getConstant('DatePicker.Months.November'),
            December: $.cdh.languageConstant.getConstant('DatePicker.Months.December'),
        }
        const weekDaysLabel = {
            Sunday: $.cdh.languageConstant.getConstant('DatePicker.Week-Days.Sunday'),
            Monday: $.cdh.languageConstant.getConstant('DatePicker.Week-Days.Monday'),
            Tuesday: $.cdh.languageConstant.getConstant('DatePicker.Week-Days.Tuesday'),
            Wednesday: $.cdh.languageConstant.getConstant('DatePicker.Week-Days.Wednesday'),
            Thursday: $.cdh.languageConstant.getConstant('DatePicker.Week-Days.Thursday'),
            Friday: $.cdh.languageConstant.getConstant('DatePicker.Week-Days.Friday'),
            Saturday: $.cdh.languageConstant.getConstant('DatePicker.Week-Days.Saturday'),
        }

        const weekDaysHoverLabel = {
            Sunday: $.cdh.languageConstant.getConstant('DatePicker.WeekDays-FullName.Sunday'),
            Monday: $.cdh.languageConstant.getConstant('DatePicker.WeekDays-FullName.Monday'),
            Tuesday: $.cdh.languageConstant.getConstant('DatePicker.WeekDays-FullName.Tuesday'),
            Wednesday: $.cdh.languageConstant.getConstant('DatePicker.WeekDays-FullName.Wednesday'),
            Thursday: $.cdh.languageConstant.getConstant('DatePicker.WeekDays-FullName.Thursday'),
            Friday: $.cdh.languageConstant.getConstant('DatePicker.WeekDays-FullName.Friday'),
            Saturday: $.cdh.languageConstant.getConstant('DatePicker.WeekDays-FullName.Saturday'),
        }

        const selectLabels = {
            SelectYear: $.cdh.languageConstant.getConstant('DatePicker.select-year'),
            SelectMonth: $.cdh.languageConstant.getConstant('DatePicker.select-month'),
            NextMonth: $.cdh.languageConstant.getConstant('DatePicker.next-month'),
            PreviousMonth: $.cdh.languageConstant.getConstant('DatePicker.previous-month')
        }

        //initialize datepicker
        var options = $.extend(true,
            {
                format: "mmm d, yyyy", today: '', close: '', clear: $.cdh.languageConstant.getConstant('DatePicker.Clear'), editable: true, closeOnClear: false,
                monthsFull: [monthsLabel.January, monthsLabel.February, monthsLabel.March, monthsLabel.April, monthsLabel.May, monthsLabel.June, monthsLabel.July, monthsLabel.August, monthsLabel.September, monthsLabel.October, monthsLabel.November, monthsLabel.December],
                weekdaysShort: [weekDaysLabel.Sunday, weekDaysLabel.Monday, weekDaysLabel.Tuesday, weekDaysLabel.Wednesday, weekDaysLabel.Thursday, weekDaysLabel.Friday, weekDaysLabel.Saturday],
                weekdaysFull: [weekDaysHoverLabel.Sunday, weekDaysHoverLabel.Monday, weekDaysHoverLabel.Tuesday, weekDaysHoverLabel.Wednesday, weekDaysHoverLabel.Thursday, weekDaysHoverLabel.Friday, weekDaysHoverLabel.Saturday],
                labelMonthNext: selectLabels.NextMonth,
                labelMonthPrev: selectLabels.PreviousMonth,
                labelMonthSelect: selectLabels.SelectMonth,
                labelYearSelect: selectLabels.SelectYear
            },
            allBindingsAccessor().datepickerOptions);
        const disabledDatepicker = 'disableFields' in bindingContext.$data ? bindingContext.$data.disableFields() : false;

        var picker = $(element).pickadate(options).pickadate('picker');
        const holder = picker.$root.find('.picker__holder');
        holder.attr('role', 'dialog').attr('aria-modal', 'true');
        
        var labelledBy = picker.$node.attr('aria-labelledby');
        var label = picker.$node.attr('aria-label');
        if (labelledBy) {
            // picker.$node.removeAttr('aria-labelledby');
            holder.attr('aria-labelledby', labelledBy);
        } else if (label) {
            picker.$node.removeAttr('aria-label');
            holder.attr('aria-label', label);
        }

        // disable manual input for mobile devices
        var readonly = ('ontouchend' in window);
        $(element).prop('readonly', readonly);
        // $(element).attr('aria-readonly', readonly); // possible not necessary (left 'aria-readonly' as 'false' to save our manual input scripts)

        const adaCompliantAriaLabel = $(element)?.attr('name') || ''
        var openButton = $('<button>', {
            type: 'button',
            class: 'picker__open-button',
            'aria-label': adaCompliantAriaLabel !== '' ? `Open ${adaCompliantAriaLabel} picker` : 'Open calendar',
            text: 'Open calendar',
        });
        openButton.insertAfter($(element));

        // add the text field for focus on it when datepicker is readonly (to move focus from an another fields)
        if (readonly && $.cdh.isMobile) {
            var focusingInputWrapper = $('<div/>', {
                id: $(element).attr('id') + '_focusing-input-wrapper',
                class: 'datepicker-focusing-input-wrapper'
            });
            var focusingInput = $('<input>', {
                type: 'radio',
                name: $(element).attr('id') + '_focusing-input-wrapper-name',
                id: $(element).attr('id') + '_focusing-input',
                class: 'datepicker-focusing-input',
                tabindex: picker.$node.attr('tabindex')
            });
            focusingInput.appendTo(focusingInputWrapper);
            focusingInputWrapper.insertAfter($(element));
        }

        // manual input selects fix (datepicker don't set state to 'open' when manual input is enabled. that's why a month and a year selects are generated in disabled state)
        picker.on({
            open: function () {
                if (readonly && $.cdh.isMobile) {
                    focusingInput.focus();
                }
                if ($(element).is(":disabled")) {
                    picker.close();
                }
            },
            close: function () {
                $(element).siblings('button').focus();                
            },         
                 
          
            render: function () {
                picker.$holder.find('select.picker__select--month').prop('disabled', false);
                picker.$holder.find('select.picker__select--year').prop('disabled', false);
                makeCalendarAvailable();
                if (disabledDatepicker) {
                    disableCalendarFocusible();
                } else {
                    enableCalendarFocusible();
                }
                
            }
        });



        // NOTE: onClose event doesn't work. that's why we observe picker attributes changes.
        function removeIncorrectInputAttrs() {
            $(element).removeAttr('aria-haspopup').removeAttr('aria-expanded').removeAttr('aria-owns');
            $(element).siblings('div').removeAttr('aria-hidden');
        }

        const pickerObserverConfig = {
            attributes: true,
            childList: false,
            subtree: false
        };
        const pickerObserverCallback = function(mutationsList, observer) {
            for (let i = 0; i < mutationsList.length; i++) {
                const mutation = mutationsList[i];
                if (mutation.type === 'attributes') {
                    if (mutation.attributeName === 'aria-hidden') {
                        removeIncorrectInputAttrs();
                    }
                }
            }
        };
        const pickerObserver = new MutationObserver(pickerObserverCallback);
        pickerObserver.observe(picker.$root.get(0), pickerObserverConfig);
        removeIncorrectInputAttrs();



        function parseDate(date, defaultValue) {
            if (!date) {
                return moment(defaultValue);
            }

            if (moment.isMoment(date)) {
                return date;
            }

            let result = moment(date, 'MMM D, YYYY');
            if (result.isValid()) {
                return result;
            }

            result = moment(date, 'YYYY-MM-DDTHH:mm:ss');
            if (result.isValid()) {
                return result;
            }

            return moment(date);
        }
        
        function setMin(newMinDate) {
            let newMin = parseDate(newMinDate, 1);
            let min = picker.get('min');
            let minMoment = min ? moment({years: min.year, months: min.month, day: min.date}) : null;

            if (!minMoment || !newMin.isSame(minMoment)) {
                picker.set('min', newMin.toDate());
            }

            let selectedDate = ko.unwrap(valueAccessor());

            // NOTE: WCP-5285 fix.
            // "new Date(selectedDate).valueOf()" calculates date with timezone,
            // and returns different value unlinke MomentJS.
            // most notably in dates with big GMT offset. for example, GMT-0700.
            // if (selectedDate && (new Date(selectedDate).valueOf() < newMin.toDate().valueOf()))
            if (selectedDate && (parseDate(selectedDate, 1).toDate().valueOf() < newMin.toDate().valueOf()))
                valueAccessor()('');
        }

        function setMax(newMaxDate) {
            let newMax = parseDate(newMaxDate, 4200000000000);
            let max = picker.get('max');
            let maxMoment = max ? moment({years: max.year, months: max.month, day: max.date}) : null;

            if (!maxMoment || !newMax.isSame(maxMoment)) {
                picker.set('max', newMax.toDate());
            }

            let selectedDate = ko.unwrap(valueAccessor());

            // NOTE: WCP-5285 fix.
            // "new Date(selectedDate).valueOf()" calculates date with timezone,
            // and returns different value unlinke MomentJS.
            // most notably in dates with big GMT offset. for example, GMT-0700.
            // if (selectedDate && (new Date(selectedDate).valueOf() > newMax.toDate().valueOf()))
            if (selectedDate && (parseDate(selectedDate, 1).toDate().valueOf() > newMax.toDate().valueOf()))
                valueAccessor()('');
        }
        
        let bindingMinDate = allBindingsAccessor().minDate;
        if (ko.isObservable(bindingMinDate)) {
            if (bindingMinDate()) {
                setMin(bindingMinDate());
            }
            bindingMinDate.subscribe(setMin);
        } else if(bindingMinDate) {
            setMin(bindingMinDate);
        }

        let bindingMaxDate = allBindingsAccessor().maxDate;
        if (ko.isObservable(bindingMaxDate)) {
            if (bindingMaxDate()) {
                setMax(bindingMaxDate());
            }
            bindingMaxDate.subscribe(setMax);
        } else if(bindingMaxDate) {
            setMax(bindingMaxDate);
        }

        var dateFormat = "MMM D, YYYY";
        var constInvalidDate = 'Invalid date';

        if (typeof ko.unwrap(valueAccessor()) != "string") {
            var value = moment(ko.unwrap(valueAccessor())).format(dateFormat);
            if (value != constInvalidDate) {
                valueAccessor(value);
            }
        }

        // onchange event handler
        function onChangeHandler() {
            var pickerValue = picker.get();
            var possibleObservable = valueAccessor();

            if (!pickerValue) {
                return;
            }

            var pickerValueCorrected = correctDate(pickerValue);
            if (pickerValueCorrected === false) {
                picker.clear();
                return;
            }

            let newMoment = moment(pickerValueCorrected.month + '/' + pickerValueCorrected.day + '/' + pickerValueCorrected.year);
            let setDate = new Date(newMoment);
            // correct time
            setDate.setHours(0);
            setDate.setMinutes(0);
            setDate.setSeconds(0);
            setDate.setMilliseconds(0);
            
            if (bindingMinDate) {
                let value = ko.isObservable(bindingMinDate) && bindingMinDate() ? bindingMinDate() : bindingMinDate;
               
                let minDate = moment.isMoment(value) ? value.toDate() : new Date(value);
                minDate.setHours(0);
                minDate.setMinutes(0);
                minDate.setSeconds(0);
                minDate.setMilliseconds(0);

                if (setDate.valueOf() < minDate.valueOf()){
                    picker.clear();
                    return;
                }
            }
            if (bindingMaxDate) {
                let value = ko.isObservable(bindingMaxDate) && bindingMaxDate() ? bindingMaxDate() : bindingMaxDate;

                let maxDate = moment.isMoment(value) ? value.toDate() : new Date(value);
                maxDate.setHours(23);
                maxDate.setMinutes(59);
                maxDate.setSeconds(59);
                maxDate.setMilliseconds(999);

                if (setDate.valueOf() > maxDate.valueOf()) {
                    picker.clear();
                    return;
                }
            }
            
            var formatedDate = newMoment.format("MMM D, YYYY");

            if (pickerValue == formatedDate) {
                possibleObservable(pickerValue);
                if (hidePicker) {
                    picker.set('select', pickerValue);
                    picker.set('highlight', pickerValue);
                    disableCalendarFocusible();
                }
                return;
            }

            if (ko.isWritableObservable(possibleObservable)) {
                possibleObservable(''); // Fixes the bug when the current value is equal to the previous but in other format
                //possibleObservable(pickerValue);
                possibleObservable(formatedDate);
            }
        }

        var hidePicker = true;
        var timeoutDelay = 300;

        //handle the field blur
        ko.utils.registerEventHandler(element, 'blur', function () {
            onChangeHandler();
            disableCalendarFocusible();
            hidePicker = true;
            picker.close();
        });

        ko.utils.registerEventHandler(element, 'change', function() {
            var pickerValue = picker.get();
            var possibleObservable = valueAccessor();
            if (!pickerValue) {
                possibleObservable('');
                return;
            }
        });

        ko.utils.registerEventHandler(openButton, 'click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            elementClick();
        });

        // element click
        function elementClick() {
            if ('openedPicker' in window) {
                window.openedPicker.close();
            }
            window.openedPicker = picker;
            hidePicker = true;
            if (!picker.get('open')) {
                enableCalendarFocusible();
                setFocusInCalendar();
                picker.open(false);
            }
        }

        function calendarMovingHandler(e) {
            const availableKeyCodes = [37, 38, 39, 40];
            if (!availableKeyCodes.includes(e.keyCode)) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            const $nextDay = getNextFieldForMovingCalendar(e.target, e.keyCode);
            if ($nextDay) {
                const $prevDay = $(e.target);
                $prevDay.attr('tabindex', '-1');
                $prevDay.removeAttr('aria-selected');
                $prevDay.removeClass('picker__day--highlighted');

                $nextDay.attr('tabindex', '0');
                $prevDay.attr('aria-selected', 'true');
                $nextDay.addClass('picker__day--highlighted');

                $nextDay.focus();
            }
        }

        function getNextFieldForMovingCalendar(currentDay, buttonCode) {
            const $td = $(currentDay.closest('td'));
            const $tr = $td.closest('tr');
            const $tbody = $tr.closest('tbody');
            let currentFieldIndex = $td.index();
            let currentRowIndex = $tr.index();

            if (buttonCode === 37) { // Left
                if (currentFieldIndex === 0) {
                    return;
                }
                currentFieldIndex--;
            } else if (buttonCode === 39) { // Right
                if (currentFieldIndex === 6) {
                    return;
                }
                currentFieldIndex++;
            } else if (buttonCode === 38) { // Top
                if (currentRowIndex === 0) {
                    return;
                }
                currentRowIndex--;
            } else if (buttonCode === 40) { // Bottom
                if (currentRowIndex === 6) {
                    return;
                }
                currentRowIndex++;
            }
            const $nextDay = $tbody.find('tr').eq(currentRowIndex).find('.picker__day').eq(currentFieldIndex);

            if ($nextDay.hasClass('picker__day--disabled')) {
                return;
            }

            return $nextDay
        }

        function makeCalendarAvailable() {
            const allDays = picker.$root[0].querySelectorAll('.picker__day');
            const prevButton = picker.$root[0].querySelector('.picker__nav--prev');
            const nextButton = picker.$root[0].querySelector('.picker__nav--next');
            const clearButton = picker.$root[0].querySelector('.picker__button--clear');
            const activedescendantElements = picker.$root[0].querySelectorAll('[aria-activedescendant]');
            const yearSelect = picker.$root[0].querySelector(".picker__select--year");
            const monthSelect = picker.$root[0].querySelector(".picker__select--month");

            activedescendantElements.forEach(function (el) {
                el.removeAttribute('aria-activedescendant');
            });

            for (let i = 0; i < allDays.length; i++) {
                allDays[i].setAttribute('role', 'button');
                $(allDays[i]).parent().removeAttr('role');
                allDays[i].setAttribute('tabindex', '-1');
                allDays[i].addEventListener('keydown', calendarMovingHandler);
            }

            [monthSelect, yearSelect].forEach(function (el) {
                if (!el) {
                    return;
                }
                el.addEventListener('keydown', function (e) {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        e.stopPropagation();
                    }
                });
            });

            [clearButton, prevButton, nextButton].forEach(function (el) {
                el.addEventListener('keydown', function (e) {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        e.preventDefault();
                        e.stopPropagation();
                        const selector = '.' + e.target.classList[0];
                        setTimeout(function () {
                            picker.$root.find(selector).focus();
                        }, 200);
                        e.target.click();
                    }
                });
            });

            allDays.forEach(function(el) {
                el.addEventListener('keydown', function (e) {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.target.click();
                        disableCalendarFocusible();
                    }
                });
            });

            clearButton.addEventListener('keydown', function (e) {
                if (e.keyCode === 9 && e.shiftKey === false) {
                    e.preventDefault();
                    prevButton.focus();
                }                 
            });

            prevButton.addEventListener('keydown', function (e) {
                if (e.keyCode === 9 && e.shiftKey === true) {
                    e.preventDefault();
                    clearButton.focus();
                }               
            });
           
            clearButton.removeAttribute('disabled');
            clearButton.addEventListener('click', function (e) {
                picker.$root.find('.picker__button--clear').removeAttr('disabled');
            });
        }

        function setFocusInCalendar() {
            const focusibleElement = picker.$root[0].querySelector(".picker__nav--prev");
            
            if (focusibleElement) {
                focusibleElement.focus();
            }
        }

        function enableCalendarFocusible() {
            const prevButton = picker.$root[0].querySelector(".picker__nav--prev");
            const nextButton = picker.$root[0].querySelector(".picker__nav--next");
            const selectedDay = picker.$root[0].querySelector(".picker__day--highlighted");
            const clearButton = picker.$root[0].querySelector(".picker__button--clear");
            const yearSelect = picker.$root[0].querySelector(".picker__select--year");
            const monthSelect = picker.$root[0].querySelector(".picker__select--month");

            if (prevButton) {
                if (prevButton.classList.contains('picker__nav--disabled')) {
                    prevButton.setAttribute('aria-disabled', 'true');
                } else {
                    prevButton.setAttribute('tabindex', '0');
                }
            }
            if (nextButton) {
                if (nextButton.classList.contains('picker__nav--disabled')) {
                    nextButton.setAttribute('aria-disabled', 'true');
                } else {
                    nextButton.setAttribute('tabindex', '0');
                }
            }
            if (selectedDay) {
                selectedDay.setAttribute('tabindex', '0');
            }
            if (clearButton) {
                clearButton.setAttribute('tabindex', '0');
            }
            if (yearSelect) {
                if (prevButton) {
                    $(yearSelect).before(prevButton);
                }
                yearSelect.setAttribute('tabindex', '0');
            }
            if (monthSelect) {
                monthSelect.setAttribute('tabindex', '0');
            }
        }

        function disableCalendarFocusible() {
            const prevButton = picker.$root[0].querySelector(".picker__nav--prev");
            const nextButton = picker.$root[0].querySelector(".picker__nav--next");
            const selectedDay = picker.$root[0].querySelector(".picker__day--highlighted");
            const clearButton = picker.$root[0].querySelector(".picker__button--clear");
            const yearSelect = picker.$root[0].querySelector(".picker__select--year");
            const monthSelect = picker.$root[0].querySelector(".picker__select--month");
            
            if (prevButton) {
                prevButton.setAttribute('tabindex', '-1');
            }
            if (nextButton) {
                nextButton.setAttribute('tabindex', '-1');
            }
            if (selectedDay) {
                selectedDay.setAttribute('tabindex', '-1');
            }
            if (clearButton) {
                clearButton.setAttribute('tabindex', '-1');
            }
            if (yearSelect) {
                yearSelect.setAttribute('tabindex', '-1');
            }
            if (monthSelect) {
                monthSelect.setAttribute('tabindex', '-1');
            }
        }

        //handle the document click
        $(document).on('click touchend', function () {
            hidePicker = true;
            picker.close();
            disableCalendarFocusible();
        });
        picker.$holder.on('keydown', function (e) {
            if (e.keyCode == 27) {
                hidePicker = true;
                openButton.focus();
                picker.close();
                disableCalendarFocusible();
            }
        });

        //handle the picker holder click
        picker.$holder.off('mousedown');
        picker.$holder.on('mousedown touchend', function (e) {
            hidePicker = false;

            // IE hide picker fix (IE don't hide calendar after date was selected)
            var target = $(e.target);
            var possibleObservable = valueAccessor();
            if (target.hasClass('picker__day') && !target.hasClass('picker__day--disabled')) {
                setTimeout(function () {
                    hidePicker = true;
                    picker.close();
                    possibleObservable(picker.$node.val());
                    disableCalendarFocusible();
                }, timeoutDelay);
            }
            if (target.hasClass('picker__button--clear')) {
                setTimeout(function() {
                    possibleObservable(picker.$node.val());
                }, timeoutDelay);
            }

            e.stopPropagation();
            if (!target.hasClass('picker__select--month') &&
                !target.hasClass('picker__select--year') &&
                !target.hasClass('picker__nav--prev') &&
                !target.hasClass('picker__nav--next') &&
                !target.hasClass('picker__button--clear')) {
                setTimeout(function() {
                    element.focus();
                }, timeoutDelay);
            }
        });

        //handle disposal (if KO removes by the template binding)
        ko.utils.domNodeDisposal.addDisposeCallback(element, picker.stop);
    },

    //update the control when the view model changes
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var picker = $(element).pickadate('picker');
        var date = ko.unwrap(valueAccessor());
        date = $.cdh.helper.removeMillisecondsFromDate(date);

        var pickerValueCorrected = correctDate(date);
        if (pickerValueCorrected === false) {
            var parseServerFormat = function(date, format) {
                if (moment(date, format).format(format) == date) {
                    return correctDate(moment(date, format).format("MMM D, YYYY"));
                }

                return false;
            };

            pickerValueCorrected = parseServerFormat(date, 'YYYY-MM-DDTHH:mm:ss');
            if (!pickerValueCorrected)
                pickerValueCorrected = parseServerFormat(date, 'YYYY-MM-DDTHH:mm:ssZ');

            //Check service date format
            
            if (pickerValueCorrected === false) {
                picker.clear();
                return;
            }
        }

        var newMoment = moment(pickerValueCorrected.month + '/' + pickerValueCorrected.day + '/' + pickerValueCorrected.year);
        var newValue = newMoment.isValid() ? newMoment.format("MMM D, YYYY") : '';
        var currentValue = picker.get();

        if (newValue == currentValue) {
            return;
        }
        if (!newValue) {
            picker.clear();
            return;
        }

        const openButton = element.parentNode.querySelector('.picker__open-button');
        if (openButton && 'disableFields' in bindingContext.$data) {
            openButton.disabled = bindingContext.$data.disableFields();
        }        

        picker.set('select', newValue);
        picker.set('highlight', newValue);
    }
};

ko.bindingHandlers.date = {
    update: function (element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        var text = value != null ? moment(value).format("MMM D, YYYY") : '';
        ko.utils.setTextContent(element, text);
    }
}

ko.bindingHandlers.dateFormatter = {
    update: function (element, valueAccessor) {
        var binding = ko.unwrap(valueAccessor());
        var value = ko.unwrap(binding.date);
        var dt = value != null ? moment(value).format("MMM D, YYYY") : '';
        var text = binding.formatter(dt);
        ko.utils.setHtml(element, text);
    }
}

ko.bindingHandlers.dateFormat = {
    update: function (element, valueAccessor) {
        let binding = ko.unwrap(valueAccessor());
        let value = ko.unwrap(binding.date);
        let momentValue = value instanceof moment ? value : moment(value);
        let format = ko.unwrap(binding.format);
        let text = value ? momentValue.format(format || "MMM D, YYYY") : '';
        ko.utils.setTextContent(element, text);
    }
};

ko.bindingHandlers.datetime = {
    update: function (element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        var datetime = value != null
            ? moment(value).format("[<span>]MMM D, YYYY[</span> <span>]h:mm a[</span>]")
            : '';
        $(element).html(datetime);
    }
}

ko.bindingHandlers.time = {
    update: function (element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        var text = value != null ? moment(value).format("h:mm a") : '';
        ko.utils.setTextContent(element, text);
    }
}

ko.bindingHandlers.accountPlanDatesRange = {
    update: function(element, valueAccessor) {
        var obj = ko.unwrap(valueAccessor());
        var accountType = obj.AccountType;
        var start = obj.PlanStartDate;
        var end = obj.PlanEndDate;
        var showDeadlines = obj.ShowDeadlines;

        if (accountType == $.cdh.enums.accountType.transit || !showDeadlines) {
            ko.utils.setTextContent(element, "");
            return;
        }

        var text = '(' + moment(start).format("MM/DD/YYYY") + '-' + moment(end).format("MM/DD/YYYY") + ')';
        ko.utils.setTextContent(element, text);
    }
}